import { R } from '@/features/booking/resources/Texts.resx';
import { Button, Card } from '@/components';

export const Disclaimer = ({
    disclaimer,
    onAcceptDisclaimer,
}: {
    disclaimer: string;
    onAcceptDisclaimer?: () => void;
}) => {
    return (
        <Card alwaysCard={false}>
            <h2 className="mb-6">{R.DisclaimerHeader}</h2>
            <div className="mb-8 whitespace-break-spaces">{disclaimer}</div>
            <div className="flex w-full flex-row justify-end">
                <Button variant="primary" onClick={onAcceptDisclaimer}>
                    {R.DisclaimerButtonText}
                </Button>
            </div>
        </Card>
    );
};
